<template>
  <div
    class="relative p-5 overflow-hidden border shadow-sm bg-white/80 dark:bg-slate-900/80 border-slate-200 dark:border-slate-700 rounded-2xl backdrop-blur"
    role="status"
    :aria-label="ariaLabel"
  >
    <span
      class="block h-3 w-24 rounded bg-slate-200 dark:bg-slate-700 animate-pulse mb-4"
    ></span>
    <div class="space-y-3">
      <span
        v-for="n in 3"
        :key="`offer-line-${n}`"
        class="flex justify-between gap-3"
      >
        <span
          class="h-3 w-20 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
        ></span>
        <span
          class="h-3 w-16 rounded bg-slate-100 dark:bg-slate-800 animate-pulse"
        ></span>
      </span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  ariaLabel: { type: String, default: "Loading" },
});
</script>
